import * as React from "react";
import { locKeys } from "components/flexComponents/WizardFlightPWA/components/l10n";
import { FlightTypeMenuProps, FlightTypeMenuItem } from "components/flexComponents/WizardFlightPWA/typings";
import { observer } from "mobx-react";
import { UitkMenu, UitkMenuTrigger, UitkMenuContainer, PositionType, UitkMenuList } from "uitk-react-menu";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { useLocalization } from "@shared-ui/localization-context";
import { FlightType } from "src/stores/wizard/state/flight/typings";
import { UitkLink, UitkLinkAlign } from "uitk-react-link";

export const FlightTypeMenu = observer((props: FlightTypeMenuProps) => {
  const { formatText } = useLocalization();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const linkRef: React.RefObject<HTMLAnchorElement> = React.createRef();

  const onMenuItemClick = (flightType: FlightType) => () => {
    setIsMenuOpen(false);
    props.onFlightTypeUpdate(flightType);
    linkRef.current?.focus();
  };

  function createMenuItem(locKey: string, pwaSubLob: FlightType): FlightTypeMenuItem {
    return {
      attributes: {
        role: "menuItem",
        tabindex: 0,
      },
      className: "uitk-list-item",
      href: "#",
      label: formatText(locKey),
      onClick: onMenuItemClick(pwaSubLob),
      typeAnchor: true,
    };
  }

  const menuItems: FlightTypeMenuItem[] = [];
  menuItems.push(createMenuItem(locKeys.flightRoundTripText, FlightType.ROUND_TRIP));
  if (props.showOneway !== false) {
    menuItems.push(createMenuItem(locKeys.flightOneWayText, FlightType.ONE_WAY));
  }
  if (props.showMulticity !== false) {
    menuItems.push(createMenuItem(locKeys.flightMultiCityText, FlightType.MULTI_CITY));
  }

  /* istanbul ignore next */
  const onMenuClick = (event: React.MouseEvent) => {
    event.preventDefault();
    setIsMenuOpen((prevState) => !prevState);
  };

  return (
    <UitkMenu id="flight-type-menu" isOpen={isMenuOpen} onTriggerClick={onMenuClick}>
      <UitkMenuTrigger>
        <UitkLink iconPos={UitkLinkAlign.RIGHT}>
          <a href="" className="flight-menu" role="button" ref={linkRef}>
            {props.setFlightType()}
            <UitkIcon name="expand_more" size={UitkIconSize.SMALL} />
          </a>
        </UitkLink>
      </UitkMenuTrigger>
      <UitkMenuContainer position={PositionType.LEFT}>
        <UitkMenuList items={menuItems} />
      </UitkMenuContainer>
    </UitkMenu>
  );
});
